//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Object.js";
let d=[[],[],[]];
SPLM.InferSnapType = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.InferSnapType";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.InferSnapType.SnapType = Object.freeze({
    "None" : "None", "Start" : "Start", "End" : "End", "Mid" : "Mid", "Knot" : "Knot", "Center" : "Center", "Exist" : "Exist", "Quadrant" : "Quadrant", "Intersection" : "Intersection", "Curve" : "Curve", "Surf" : "Surf", "Origin" : "Origin", "DrfAid" : "DrfAid", "DrfTangent" : "DrfTangent", "Pole" : "Pole", "Defining" : "Defining", "ConicAnchor" : "ConicAnchor", "BoundedGrid" : "BoundedGrid", "FacetVertex" : "FacetVertex"});

export default SPLM;